import React from 'react'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import { useToast } from '@chakra-ui/react'
import store from '../../app/store'
import './customToast.less'
const icons = {
  success: ['fas', 'circle-check'],
  info: ['fas', 'circle-info'],
  error: ['fas', 'circle-exclamation'],
  warning: ['fas', 'circle-exclamation'],
}
const CustomToastComponent = ({ close, status, title, description }) => {
  return (
    <div className={`toast-item visible toast-${status}`}>
      <div className='toast-item-container'>
        <FontAwesomeIconComponent icon={icons[status]} addClassName='toast-icon' size='sm' />
        <div className='toast-text-container'>
          <p className='toast-title'>{title}</p>
          <p className='toast-description'>{description}</p>
        </div>
      </div>
      <FontAwesomeIconComponent
        icon={['far', 'xmark']}
        onClick={close}
        size=''
        addClassName='toast-close'
      />
    </div>
  )
}

// eslint-disable-next-line react/display-name
const withToast = Component => props => {
  const chakraToast = useToast({
    position: 'top-right',
    duration: 4000,
    isClosable: true,
  })
  const widgetToast = toastConfig => {
    return chakraToast({
      ...toastConfig,
      render() {
        return <CustomToastComponent close={close} {...toastConfig} />
      },
    })
  }
  const toastIdRef = React.useRef()
  function close() {
    if (toastIdRef.current) {
      chakraToast.close(toastIdRef.current)
    }
  }
  const state = store.getState()
  const isWidget = state.appReducer.isWidget
  function addToast(toastProps) {
    const toastFunc = isWidget ? widgetToast : chakraToast
    toastIdRef.current = toastFunc(toastProps)
  }

  return <Component {...props} toast={addToast} />
}

export default withToast
